module.exports = __webpack_public_path__ + "static/media/customer-usa-dry.30676db6.png";